import styled from 'styled-components';

export const TextInput = styled.input`
  display: block;
  margin: 0;
  padding: 0.4rem 0.8rem;
  border: 0.1rem solid ${props => props.theme.checkoutPage.inputTextBorderColor};
  background: ${p => p.error ? p.theme.checkoutPage.inputErrorBackgroundColor : p.theme.checkoutPage.inputTextBackground};
  box-shadow: inset 0 0.1rem 0.2rem ${props => props.theme.checkoutPage.inputTextShadowColor};
  color: ${props => props.theme.checkoutPage.inputTextColor};
  font-size: 1.8rem;
  font-weight: normal;
  line-height: 3.6rem;
  box-sizing: border-box;
  width: 100%;
`;

export const TextInputError = styled.span`
  color: ${props => props.theme.checkoutPage.requiredMessageColor};
`;

export const Select = styled.select`
  border: 0.1rem solid ${props => props.theme.checkoutPage.inputTextBorderColor};
  background-color: ${props => props.theme.checkoutPage.inputTextBackground};
  box-shadow: inset 0 0.1rem 0.2rem #b4b4b4;
  color: ${props => props.theme.checkoutPage.inputTextColor};
  font-size: 1.8rem;
  width: 100%;
  height: 4.8rem;
`;



// WEBPACK FOOTER //
// ./components/ReduxForm/reduxForm.style.js